import { createSlice } from '@reduxjs/toolkit';
import { ReducerStatus } from 'utils/constants';
import {
  addLearningPlanCoursesAction,
  deleteLearningPlanCourseAction,
  getLearningPlanCoursesAction,
  updateLearningPlanCourseOrderNoAction,
} from './learningPlanCourse-action';

const learningPlanCourseSlice = createSlice({
  name: 'learningPlanCourse',
  initialState: {
    learningPlanCourses: [],
    getLearningPlanCourses: {
      status: ReducerStatus.IDLE,
      error: null,
    },
    addLearningPlanCourses: {
      status: ReducerStatus.IDLE,
      error: null,
      modal: false,
      id: null,
    },
    updateLearningPlanCourseOrderNo: {
      status: ReducerStatus.IDLE,
      error: null,
    },
    deleteLearningPlanCourse: {
      status: ReducerStatus.IDLE,
      courseId: null,
      learningPlanId: null,
      modal: false,
      error: null,
    },
  },
  reducers: {
    setLearningPlanCourses(state, action) {
      state.learningPlanCourses = action.payload;
    },
    setDeleteLearningPlanCourse(state, action) {
      state.deleteLearningPlanCourse = {
        ...state.deleteLearningPlanCourse,
        ...action.payload,
      };
    },
    setAddLearningPlanCourses(state, action) {
      state.addLearningPlanCourses = {
        ...state.addLearningPlanCourses,
        ...action.payload,
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Learning Plan's Courses
      .addCase(getLearningPlanCoursesAction.pending, (state) => {
        state.getLearningPlanCourses.status = ReducerStatus.LOADING;
      })
      .addCase(getLearningPlanCoursesAction.fulfilled, (state, action) => {
        state.getLearningPlanCourses.status = ReducerStatus.SUCCEEDED;
        state.learningPlanCourses = action.payload;
      })
      .addCase(getLearningPlanCoursesAction.rejected, (state, action) => {
        state.getLearningPlanCourses.status = ReducerStatus.FAILED;
        state.getLearningPlanCourses.error = action.payload;
      })
      // Add Learning Plan Courses
      .addCase(addLearningPlanCoursesAction.pending, (state) => {
        state.addLearningPlanCourses.status = ReducerStatus.LOADING;
      })
      .addCase(addLearningPlanCoursesAction.fulfilled, (state, action) => {
        state.addLearningPlanCourses.status = ReducerStatus.SUCCEEDED;
        state.learningPlanCourses = [
          ...state.learningPlanCourses,
          ...action.payload,
        ];
      })
      .addCase(addLearningPlanCoursesAction.rejected, (state, action) => {
        state.addLearningPlanCourses.status = ReducerStatus.FAILED;
        state.addLearningPlanCourses.error = action.payload;
      })
      // Update Learning Plan's Course Order No
      .addCase(updateLearningPlanCourseOrderNoAction.pending, (state) => {
        state.updateLearningPlanCourseOrderNo.status = ReducerStatus.LOADING;
      })
      .addCase(updateLearningPlanCourseOrderNoAction.fulfilled, (state) => {
        state.updateLearningPlanCourseOrderNo.status = ReducerStatus.SUCCEEDED;
      })
      .addCase(
        updateLearningPlanCourseOrderNoAction.rejected,
        (state, action) => {
          state.updateLearningPlanCourseOrderNo.status = ReducerStatus.FAILED;
          state.updateLearningPlanCourseOrderNo.error = action.payload;
        }
      )
      // Delete Learning Plan's Course
      .addCase(deleteLearningPlanCourseAction.pending, (state) => {
        state.deleteLearningPlanCourse.status = ReducerStatus.LOADING;
      })
      .addCase(deleteLearningPlanCourseAction.fulfilled, (state, action) => {
        state.deleteLearningPlanCourse.status = ReducerStatus.SUCCEEDED;
        state.learningPlanCourses = state.learningPlanCourses.filter(
          (learningPlanCourse) =>
            learningPlanCourse.course.id !== action.payload
        );
      })
      .addCase(deleteLearningPlanCourseAction.rejected, (state, action) => {
        state.deleteLearningPlanCourse.status = ReducerStatus.FAILED;
        state.deleteLearningPlanCourse.error = action.payload;
      });
  },
});

export const learningPlanCourseActions = learningPlanCourseSlice.actions;

export default learningPlanCourseSlice;
